

































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { AxiosResponse } from "axios";
import VoucherPrintVue from "@/components/Print/VoucherPrint.vue";
import CoverPrintVue from "@/components/Print/CoverPrint.vue";
import incomeData, { Income } from "../data/incomeData";
import IncomePrintVue from "@/components/Print/IncomePrint.vue";
import ActPrintVue from "@/components/Print/ActPrint.vue";
import activityData from "../data/activityData";
import QuaterIncomePrintVue from "@/components/Print/QuaterIncomePrint.vue";
import SheetPrintVue from "@/components/Print/SheetPrint.vue";
import balanceSheetData, { BalanceSheetData } from "../data/balanceSheetData";
import CashPrintVue from "@/components/Print/CashPrint.vue";
import QuaterCashPrintVue from "@/components/Print/QuaterCashPrint.vue";
import FixPrintVue from "@/components/Print/FixPrint.vue";
import BalancePrintVue from "@/components/Print/BalancePrint.vue";
import SubsidiaryPrintVue from "@/components/Print/SubsidiaryPrint.vue";
import SubsidiaryAllPrintVue from "@/components/Print/SubsidiaryAllPrint.vue";
import GenPrintVue from "@/components/Print/GenPrint.vue";
import GenAllPrintVue from "@/components/Print/GenAllPrint.vue";
import GenCoverPrintVue from "@/components/Print/GenCoverPrint.vue";
import DisPrintVue from "@/components/Print/DisPrint.vue";
import AccountingSystem from "@/data/AccountingSystem";
import IntangPrintVue from "@/components/Print/IntangPrint.vue";
import LongtermPrintVue from "@/components/Print/LongtermPrint.vue";

interface PrintItem {
    label: string;
    show: boolean;
    has?: boolean;
    change(checked: boolean): void;
    isAll?: boolean;
    isYear?: boolean;
}
@Component({
    ...mapGetters(["accountBook", "printers"]),
    components: {
        voucher: VoucherPrintVue,
        cover: CoverPrintVue,
        income: IncomePrintVue,
        activity: ActPrintVue,
        "quater-income": QuaterIncomePrintVue,
        sheet: SheetPrintVue,
        cash: CashPrintVue,
        "quater-cash": QuaterCashPrintVue,
        fix: FixPrintVue,
        balance: BalancePrintVue,
        subsidiary: SubsidiaryPrintVue,
        "subsidiary-all": SubsidiaryAllPrintVue,
        gen: GenPrintVue,
        "gen-all": GenAllPrintVue,
        "gen-cover": GenCoverPrintVue,
        "dis-print": DisPrintVue,
        intang: IntangPrintVue,
        "long-term": LongtermPrintVue
    },
})
export default class Print extends Vue {
    accountBook: AccountBookList.AccountBook = this.$store.state.accountBook;
    isThirteenRule: boolean =
        this.accountBook.accountingSystem === AccountingSystem.thirteenRule;
    isNpo: boolean =
        this.accountBook.accountingSystem === AccountingSystem.npo;
    isRural = this.accountBook.accountingSystem === AccountingSystem.rural;
    // 总账和明细账用的科目列表
    subjectList: Subject.Subject[] = [];

    printItems = {
        "凭证": {
            label: "凭证",
            show: false,
            has: true,
            change: this.checkVoucher,
        },
        "凭证封面": {
            label: "凭证封面",
            show: false,
            has: true,
            change: this.checkPrintCover,
        },
        "利润表": {
            label: "利润表",
            show: false,
            has: !this.isNpo && !this.isRural,
            change: this.checkIncome,
        },
        "业务活动表": {
            label: "业务活动表",
            show: false,
            has: this.isNpo,
            change: this.checkAct,
        },
        "季度利润表": {
            label: "季度利润表",
            show: false,
            has: !this.isNpo && !this.isRural,
            change: this.checkQuaterIncome,
        },
        "收益分配表": {
            label: "收益分配表",
            show: false,
            has: this.isRural,
            change: this.checkDis,
        },
        "资产负债表": {
            label: "资产负债表",
            show: false,
            has: true,
            change: this.checkSheet,
        },
        "现金流量表": {
            label: "现金流量表",
            show: false,
            has: !this.isRural,
            change: this.checkCash,
        },
        "季度现金流量表": {
            label: "季度现金流量表",
            show: false,
            has: !this.isRural,
            change: this.checkQuaterCash,
        },
        "固定资产": {
            label: "固定资产",
            show: false,
            has: true,
            change: this.checkFix,
        },
        "无形资产": {
            label: "无形资产",
            show: false,
            has: this.$store.state.accountBook.accountingSystem !== AccountingSystem.rural,
            change: this.checkIntang,
        },
        "长期待摊费用": {
            label: "长期待摊费用",
            show: false,
            has: this.$store.state.accountBook.accountingSystem !== AccountingSystem.rural,
            change: this.checkLongterm,
        },
        "余额表": {
            label: "余额表",
            show: false,
            has: true,
            change: this.checkBalance,
            isAll: false,
            isYear: false,
        },
        "明细账/总账封面": {
            label: "明细账/总账封面",
            show: false,
            has: true,
            change: this.checkCover,
        },
        "明细账": {
            label: "明细账",
            show: false,
            has: true,
            change: this.checkSub,
            isAll: false,
        },
        "总账": {
            label: "总账",
            show: false,
            has: true,
            change: this.checkGen,
            isAll: false,
        },
    };

    // 选择打印机
    voucherPrinter: Electron.PrinterInfo | null = null;
    sheetPrinter: Electron.PrinterInfo | null = null;
    changeVoucherPrinter(printer: Electron.PrinterInfo) {
        if (this.$utils.notNull([printer])) {
            localStorage.setItem("voucherPrinter", JSON.stringify(printer));
        } else {
            localStorage.removeItem("voucherPrinter");
        }
    }
    changeSheetPrinter(printer: Electron.PrinterInfo) {
        if (this.$utils.notNull([printer])) {
            localStorage.setItem("sheetPrinter", JSON.stringify(printer));
        } else {
            localStorage.removeItem("sheetPrinter");
        }
    }

    period: Date[] = [new Date(), new Date()];
    periodGap: Date[] = [];
    a4Options = [
        {
            value: 0,
            label: "A4单联",
        },
        {
            value: 2,
            label: "A4两联",
        },
        {
            value: 3,
            label: "A4三联",
        },
    ];
    a4Voucher = this.a4Options[0].value;
    get isA4Voucher() {
        return +this.voucherPageWidth === 21 && +this.voucherPageHeight === 29.7;
    }
    // 日期选择的下拉选项
    startTime: number = 0;
    endTime: number = 0;

    // 各打印项的list array
    vouchers: Voucher.Voucher[] = [];
    // 凭证封面显示的info信息
    startNo: string = "";
    endNo: string = "";
    pages: number = 0;

    // 更多设置 显示开关
    moreVisible = false;

    get options() {
        return {
            disabledDate: (time: Date) => {
                return (
                    time.getTime() < this.startTime ||
                    time.getTime() > this.endTime
                );
            },
        };
    }

    get endPeriod() {
        return this.$utils.simpleDateFormat(this.period[1], "m");
    }
    get starPeriod() {
        return this.$utils.simpleDateFormat(this.period[0], "m");
    }

    // getLocalPrinters() {
    //     let vPrinter = localStorage.getItem("voucherPrinter");
    //     let sPrinter = localStorage.getItem("sheetPrinter");

    //     if (vPrinter != null) this.voucherPrinter = JSON.parse(vPrinter);
    //     if (sPrinter != null) this.sheetPrinter = JSON.parse(sPrinter);
    // }

    taxPreparer = "";
    bindPeople = "";
    bookKeeper = "";
    teller = "";
    documentMaker = "";
    async mounted() {
        let a4 = localStorage.getItem("a4Voucher");
        let storage = await Vue.axios.get(
            `accounts/printer/set/find?accounterId=${this.$store.state.account.id}`
        );

        this.taxPreparer = storage.data.taxPreparer;            
        this.bindPeople = storage.data.bindPeople;        
        this.bookKeeper = storage.data.bookKeeper;        
        this.teller = storage.data.teller;        
        this.documentMaker = storage.data.documentMaker || this.$store.state.account.name;            

        let sheet = JSON.parse(storage.data.sheet);
        this.$store.dispatch("sheetChangeTop", sheet.top);
        this.$store.dispatch("sheetChangeLeft", sheet.left);
        this.$store.dispatch("sheetChangeRight", sheet.right);
        // if (!voucherPrint || voucherPrint === "undefined") {
        let voucherPrints = JSON.parse(storage.data.voucherPrint);
        localStorage.setItem("voucherPrint", JSON.stringify(voucherPrints));
        this.$store.dispatch("voucherPrintchange", voucherPrints);
        // }
        if (a4 && a4 != "undefined") {
            if (this.isA4Voucher) {
                this.a4Voucher = +JSON.parse(a4);
            } else {
                this.a4Voucher = 0;
                localStorage.setItem("a4Voucher", storage.data.aFourVoucher);
            }
        } else {
            if (this.isA4Voucher) {
                this.a4Voucher = +storage.data.aFourVoucher;
            } else {
                this.a4Voucher = 0;
            }
            localStorage.setItem("a4Voucher", storage.data.aFourVoucher);
        }
        this.voucherPageWidth = storage.data.voucherWidth;
        localStorage.setItem("voucherWidth", storage.data.voucherWidth);

        this.voucherPageHeight = storage.data.voucherHeight;
        localStorage.setItem("voucherHeight", storage.data.voucherHeight);

        this.sheetPageWidth = storage.data.sheetWidth;
        localStorage.setItem("sheetWidth", storage.data.sheetWidth);

        this.sheetPageHeight = storage.data.sheetHeight;
        localStorage.setItem("sheetHeight", storage.data.sheetHeight);

        this.vPrintDir = JSON.parse(storage.data.printVoucherDir);
        localStorage.setItem("print-v-dir", JSON.stringify(this.vPrintDir));

        this.sPrintDir = JSON.parse(storage.data.printSheetDir);
        localStorage.setItem("print-s-dir", JSON.stringify(this.sPrintDir));

        this.lineHeight = JSON.parse(storage.data.lh);
        localStorage.setItem("lh", JSON.stringify(this.lineHeight));

        this.voucherRows = storage.data.voucherRows;
        localStorage.setItem("voucherRows", this.voucherRows.toString());

        this.printWay = +storage.data.printWay;
        localStorage.setItem("printWay", this.printWay.toString());

        this.voucherFont = +storage.data.voucherFont;
        localStorage.setItem("voucherFont", this.voucherFont.toString());

        this.sheetFont = storage.data.sheetFont || localStorage.getItem("sheetFont") || 11;
        localStorage.setItem("sheetFont", this.sheetFont.toString());

        let perent = localStorage.getItem("perent");
        if (perent != null) this.percent = +perent;
        // this.getLocalPrinters();
        await this.getPeriod();
        await this.fetchSubjects();
        // this.printItems.凭证.show = true;
        // this.printItems.凭证封面.show = true;
        // this.printItems.资产负债表.show = true;
        // this.checkVoucher(true);
        // this.checkSheet(true);

        // if (this.isNpo) {
        //     this.printItems.业务活动表.show = true;
        //     // this.printItems.季度利润表.show = true;
        //     this.checkAct(true);
        // } else if (this.isRural) {
        //     this.printItems.收益分配表.show = true;
        //     this.checkDis(true);
        // } else {
        //     this.printItems.利润表.show = true;
        //     this.checkIncome(true);
        // }

        // 判断默认选择哪一个打印纸张尺寸
        const vWidth = localStorage.getItem("voucherWidth");
        const vHeight = localStorage.getItem("voucherHeight");
        if (vWidth !== null && vHeight !== null) {
            for (let i = 0; i < this.pageOptions.length; i++) {
                const v = this.pageOptions[i].value;
                if (
                    v.width === +vWidth * 10000 &&
                    v.height === +vHeight * 10000
                ) {
                    this.voucherPageSize = this.pageOptions[i];
                    break;
                }
                this.voucherPageSize =
                    this.pageOptions[this.pageOptions.length - 1];
            }
        }

        const sWidth = localStorage.getItem("sheetWidth");
        const sHeight = localStorage.getItem("sheetHeight");
        if (sWidth !== null && sHeight !== null) {
            for (let i = 0; i < this.sheetPageOptions.length; i++) {
                const v = this.sheetPageOptions[i].value;
                if (
                    v.width === +sWidth * 10000 &&
                    v.height === +sHeight * 10000
                ) {
                    this.sheetPageSize = this.sheetPageOptions[i];
                    break;
                }
                this.sheetPageSize =
                    this.sheetPageOptions[this.sheetPageOptions.length - 1];
            }
        }
    }

    async fetchSubjects() {
        let res: AxiosResponse = await Vue.axios.post("subjects/findall", {
            accountBookId: this.accountBook.id,
        });
        this.subjectList = res.data.subjects;
        this.subSubject = this.subjectList[0];
        this.genSubject = this.subjectList[0];
    }

    async getPeriod() {
        let res: AxiosResponse = await Vue.axios.get(
            `periods/${this.accountBook.id}/findperiods`
        );
        this.startTime = res.data.startTime;
        this.endTime = res.data.endTime;
        if (this.curPeriod === null)
            this.period = [
                this.$utils.strToDate(res.data.endPeriod),
                this.$utils.strToDate(res.data.endPeriod),
            ];
        else this.period = [this.curPeriod, this.curPeriod];

        this.periodGap = [this.period[1]];
    }

    //凭证
    totalAccessoryNo: string | number = ""; //附件数
    async checkVoucher(checked: boolean) {
        if (checked) {
            let res: AxiosResponse = await Vue.axios.post(
                "vouchers/findlist?page=&&size=",
                {
                    accountBookId: this.accountBook.id,
                    endPeriod: this.endPeriod,
                    startPeriod: this.starPeriod,
                    pageType: false,
                }
            );
            let content: Voucher.Voucher[] = res.data.vouchers.content;
            this.totalAccessoryNo = res.data.totalAccessoryNo;
            if (content.length > 0) {
                this.startNo = content[0].voucherNo;
                this.endNo = content[content.length - 1].voucherNo;
                this.pages = content.length;
                this.writer = content[0].writtenPerson;
            } else {
                this.startNo = "";
                this.endNo = "";
                this.pages = 0;
            }
            this.vouchers = this.$utils.pageableVoucher(
                this.$store.state.voucherRows,
                content
            );
        }
    }

    // 利润表
    incomeList: Income[][] = [];
    async checkIncome(checked: boolean) {
        this.incomeList = [];
        if (checked && !this.isNpo) {

            for (let i = 0; i < this.periodGap.length; i++) {
                const dataList = JSON.parse(JSON.stringify(incomeData.getData(this.$store.state.accountBook)));
                const date = this.periodGap[i];
                let res: AxiosResponse = await Vue.axios.post("profits/find", {
                    accountBookId: this.accountBook.id,
                    endPeriod: this.$utils.simpleDateFormat(date, "m"),
                });

                for (let j = 0; j < dataList.length; j++) {
                    dataList[j].yearCash = res.data.yearCashs[j];
                    dataList[j].monthCash = res.data.monthCashs[j];
                    if (!this.isThirteenRule) dataList[j].lastYearMonthCash = res.data.lastYearMonthCashs[j];
                }
                this.incomeList.push(dataList);
            }
        }
    }

    // 业务活动表
    actList: activityData[] = activityData.list;
    async checkAct(checked: boolean) {
        if (checked && this.isNpo) {
            let res: AxiosResponse = await Vue.axios.post("profits/find", {
                accountBookId: this.accountBook.id,
                endPeriod: this.endPeriod,
            });
            for (let i = 0; i < this.actList.length; i++) {
                if (res.data.monthUnLimit) {
                    this.actList[i].monthUnLimit = res.data.monthUnLimit[i];
                    this.actList[i].monthLimit = res.data.monthLimit[i];
                    this.actList[i].monthSum = res.data.monthSum[i];
                    this.actList[i].yearUnLimit = res.data.yearUnLimit[i];
                    this.actList[i].yearLimit = res.data.yearLimit[i];
                    this.actList[i].yearSum = res.data.yearSum[i];
                }
            }
        }
    }

    // 收益分配表
    disData: any[] = [];
    async checkDis(checked: boolean) {
        if (checked && this.isRural) {
            const res = await Vue.axios.get(`incomedistribution/find?accountBookId=${this.$store.state.accountBook.id}&endPeriod=${this.$utils.simpleDateFormat(this.period[1], "m")}`);
            this.disData = res.data;
        }
    }

    // 季度利润表
    quaterIncomeList = incomeData.getData(this.$store.state.accountBook);
    async checkQuaterIncome(checked: boolean) {
        if (checked) {
            this.quaterIncomeList = incomeData.getData(this.$store.state.accountBook);
            let res = await Vue.axios.post(
                "profits/findquarter",
                {
                    accountBookId: this.accountBook.id,
                    endPeriod: this.endPeriod,
                }
            );
            for (let i = 0; i < this.quaterIncomeList.length; i++) {
                this.quaterIncomeList[i].yearCash =
                    res.data.yearCash.monthCashs[i];
                this.quaterIncomeList[i].oneQuarterCash =
                    res.data.oneQuarterCash.monthCashs[i];
                this.quaterIncomeList[i].twoQuarterCash =
                    res.data.twoQuarterCash.monthCashs[i];
                this.quaterIncomeList[i].threeQuarterCash =
                    res.data.threeQuarterCash.monthCashs[i];
                this.quaterIncomeList[i].fourQuarterCash =
                    res.data.fourQuarterCash.monthCashs[i];
            }
        }
    }

    // 资产负债表
    sheetList: BalanceSheetData[][] = [];
    async checkSheet(checked: boolean) {
        this.sheetList = [];
        if (checked) {
            for (let i = 0; i < this.periodGap.length; i++) {
                const dataList = JSON.parse(JSON.stringify(balanceSheetData.getData(this.$store.state.accountBook)));
                const date = this.periodGap[i];
                let res: AxiosResponse = await Vue.axios.post("balancesheet/find", {
                    accountBookId: this.accountBook.id,
                    endPeriod: this.$utils.simpleDateFormat(date, "m"),
                });

                for (let j = 0; j < dataList.length; j++) {
                    //循环获取资产期末余额
                    dataList[j].assetEndBalance = res.data.assetEndBalances[j];
                    //循环获取资产期初余额
                    dataList[j].assetInitBalance = res.data.assetInitBalances[j];
                    //循环获取负债期末余额
                    dataList[j].equityEndBalance = res.data.equityEndBalances[j];
                    //循环获取负债期初余额
                    dataList[j].equityInitBalance = res.data.equityInitBalances[j];
                }
                this.sheetList.push(dataList);
            }
        }
    }

    // 现金流量表
    cashList: CashFlow.CashData[][] = [];
    async checkCash(checked: boolean) {
        this.cashList = [];
        if (checked) {
            for (let i = 0; i < this.periodGap.length; i++) {
                const date = this.periodGap[i];
                let res: AxiosResponse = await Vue.axios.post("cash/find", {
                    accountBookId: this.accountBook.id,
                    endPeriod: this.$utils.simpleDateFormat(date, "m"),
                });
                this.cashList.push(res.data.cashList);
            }
        }
    }
    // 季度现金流量表
    quaterCashList: CashFlow.CashQuaterData[] = [];
    async checkQuaterCash(checked: boolean) {
        if (checked) {
            // cash/quarter/finddetail
            let res: AxiosResponse = await Vue.axios.post(
                "cash/quarter/finddetail",
                {
                    accountBookId: this.accountBook.id,
                    endPeriod: this.endPeriod,
                }
            );
            this.quaterCashList = res.data;
        }
    }
    // 固定资产
    fixList: FixedAsset.FiexdFad[] = [];
    async checkFix(checked: boolean) {
        if (checked) {
            let res: AxiosResponse = await Vue.axios.post(
                `fixedAssets/${this.accountBook.id}/find `,
                {
                    endPeriod: this.endPeriod,
                    assetType: 1
                }
            );
            this.fixList = res.data.fads;
            if (res.data.total != null) this.fixList.push(res.data.total);
        }
    }

    // 无形资产
    intangList: FixedAsset.FiexdFad[] = [];
    async checkIntang(checked: boolean) {
        if (checked) {
            let res: AxiosResponse = await Vue.axios.post(
                `fixedAssets/${this.accountBook.id}/find `,
                {
                    endPeriod: this.endPeriod,
                    assetType: 2
                }
            );
            this.intangList = res.data.fads;
            if (res.data.total != null) this.intangList.push(res.data.total);
        }
    }

    // 长期待摊费用
    longtermList: FixedAsset.FiexdFad[] = [];
    async checkLongterm(checked: boolean) {
        if (checked) {
            let res: AxiosResponse = await Vue.axios.post(
                `fixedAssets/${this.accountBook.id}/find `,
                {
                    endPeriod: this.endPeriod,
                    assetType: 3
                }
            );
            this.longtermList = res.data.fads;
            if (res.data.total != null) this.longtermList.push(res.data.total);
        }
    }

    // 余额表
    balanceList: Balance.Balance[] = [];
    async checkBalance(checked: boolean) {
        if (checked) {
            let res: AxiosResponse = await Vue.axios.post("balances/find", {
                accountBookId: this.accountBook.id,
                startPeriod: this.$utils.simpleDateFormat(this.period[0], "m"),
                endPeriod: this.$utils.simpleDateFormat(this.period[1], "m"),
                isBNLJ: this.printItems.余额表.isYear ? 1 : 0,
            });
            if (this.printItems.余额表.isAll) {
                this.balanceList = res.data.balances;
            } else {
                let data: Balance.Balance[] = res.data.balances;
                this.balanceList = [];
                for (var i = 0; i < data.length; i++) {
                    if (data[i].pno == null) {
                        this.balanceList.push(data[i]);
                    }
                }
            }
        }
    }
    // 凭证封面
    checkPrintCover(checked: boolean) {
        if (!checked) {
            this.onlyCover = false;
        }
        // this.checkVoucher(true);

    }
    // 明细账封面
    checkCover(checked: boolean) {
        // console.log(checked)
    }

    // 明细账
    subList: Subsidiary[] = [];
    subSubject: Subject.Subject | null = null;
    async checkSub(checked: boolean) {
        if (checked && this.subSubject != null) {
            if (this.printItems.明细账.isAll) {
                let response: AxiosResponse = await Vue.axios.post(
                    "details/findall",
                    {
                        accountBookId: this.accountBook.id,
                        startPeriod: this.$utils.simpleDateFormat(
                            this.period[0],
                            "m"
                        ),
                        endPeriod: this.$utils.simpleDateFormat(
                            this.period[1],
                            "m"
                        ),
                    }
                );
                this.subList = response.data;
            } else {
                let res: AxiosResponse = await Vue.axios.post("details/find", {
                    subjectId: this.subSubject.id,
                    accountBookId: this.accountBook.id,
                    startPeriod: this.$utils.simpleDateFormat(
                        this.period[0],
                        "m"
                    ),
                    endPeriod: this.$utils.simpleDateFormat(
                        this.period[1],
                        "m"
                    ),
                });
                this.subList = res.data.subsidiarys;
            }
        }
    }

    // 总账
    genList: GeneralBalance[] = [];
    genSubject: Subject.Subject | null = null;
    async checkGen(checked: boolean) {
        if (checked && this.genSubject != null) {
            if (this.printItems.总账.isAll) {
                let response: AxiosResponse = await Vue.axios.post(
                    "general/find",
                    {
                        accountBookId: this.accountBook.id,
                        year: this.period[1].getFullYear(),
                    }
                );
                this.genList = response.data;
            } else {
                let res: AxiosResponse = await Vue.axios.post("balance/find", {
                    subjectId: this.genSubject.id,
                    accountBookId: this.accountBook.id,
                    year: this.period[1].getFullYear(),
                });
                this.genList = res.data;
            }
        }
    }

    genPeriod(date: Date) {
        if (date) return this.$utils.simpleDateFormat(date, "m");
        else return "";
    }

    // 修改时间，重新获取数据
    changePeriod() {
        // this.periodGap =
        this.periodGap = [];
        const diff = this.$utils.getMonthBetween(this.period[0], this.period[1]);
        for (let i = 0; i <= diff; i++) {
            if (i === 0) {
                this.periodGap.push(this.period[1]);
            } else {
                const date = this.$utils.dateAdd(this.period[1], "m", -i);
                this.periodGap.push(date);
            }
        }

        const keys = Object.keys(this.printItems);
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            // @ts-ignore
            const item = (<PrintItem>this.printItems[key]);
            if (item.show) item.change(item.show);
        }
    }

    // 点击打印
    startPrint(useSystem?: boolean) {
        // 判断是否选择了对应的打印机,若未选择直接弹出提示,增加健壮性
        let printVoucher: boolean = false;
        let shouldPrintSheet: boolean = false;

        printVoucher = this.printItems.凭证.show || this.printItems.凭证封面.show;

        // if (
        //     printVoucher &&
        //     !this.$utils.notNull([this.voucherPrinter]) &&
        //     this.printWay === 0
        // ) {
        //     printVoucher = false;
        //     this.$alert("请选择凭证打印机", "温馨提示");
        //     return;
        // }

        const keys = Object.keys(this.printItems);
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            // @ts-ignore
            const item = (<PrintItem>this.printItems[key]);
            if (item.label !== "凭证" && item.label !== "凭证封面" && item.show) {
                shouldPrintSheet = true;
                break;
            }
        }


        // if (
        //     shouldPrintSheet &&
        //     !this.$utils.notNull([this.sheetPrinter]) && this.printWay === 0
        // ) {
        //     this.$alert("请选择报表打印机", "温馨提示");
        //     return;
        // }
        // 渲染打印页面至打印线程
        const rightArea = <HTMLElement>document.querySelector(".right-area");
        if (printVoucher) {
            const voucherInner = (<HTMLElement>(
                rightArea.querySelector(".voucher-wrap")
            )).innerHTML;
            this.$utils.sendToElectron(
                "print-voucher",
                voucherInner,
                this.voucherPrinter,
                useSystem,
                [this.voucherPageWidth * 10000, this.voucherPageHeight * 10000],
                this.vPrintDir,
                this.printWay
            );
        }

        if (shouldPrintSheet) {
            const sheetInner = (<HTMLElement>(
                rightArea.querySelector(".sheet-wrap")
            )).innerHTML;
            this.$utils.sendToElectron(
                "print-sheet",
                sheetInner,
                this.sheetPrinter,
                useSystem,
                this.sPrintDir,
                [this.sheetPageWidth * 10000, this.sheetPageHeight * 10000],
                // JSON.stringify(this.$store.state.sheet),
                this.printWay
            );
        }

        localStorage.setItem("print-area", rightArea.innerHTML);
        // window.print();
        window.open("/print.html");
        this.$emit("close");
    }

    onlyCover: boolean = false;

    @Prop()
    curPeriod!: Date | null;

    // 自定义凭证边距设置
    margin = 24;
    padding = 30;
    percent = 100;
    reportMargin = 28;
    reportPadding = 30;

    horizontal = false;

    isclude(v: string, list: string) {
        if (v.includes("-")) {
            let ar = v.split("-");
            this.isWhether(ar[0]);
            this.isWhether(ar[1]);
            for (let i = +ar[0]; i <= +ar[1]; i++) {
                // @ts-ignore
                this[list].push(+i);
            }
        } else {
            this.isWhether(v);
            // @ts-ignore
            this[list].push(+v);
        }
    }
    // 判断选择页码是否错误
    isWhether(val: string) {
        if (parseFloat(val).toString() == "NaN") {
            throw new Error("oops");
        }
    }
    pageHandle(list: string, page: string) {
        // @ts-ignore
        this[list] = [];
        let arr = [];
        // @ts-ignore
        this[page] = this[page].replace(/，/g, ",");
        // @ts-ignore
        this[page] = this[page].replace(/~/g, "-");
        // @ts-ignore
        if (this[page] != "") {
            try {
                // @ts-ignore
                if (this[page].includes(",")) {
                    // @ts-ignore
                    arr = this[page].split(",");
                    arr.forEach((v: string) => {
                        this.isclude(v, list);
                    });
                } else {
                    // @ts-ignore
                    this.isclude(this[page], list);
                }
                // @ts-ignore
                this[list] = Array.from(new Set(this[list]));
            } catch {
                this.$message.warning("请入正确的页码");
            }
        }
    }

    // 选择页码
    genPage = "";
    genPageList = [];
    genPageChange() {
        this.pageHandle("genPageList", "genPage");
    }

    subPage = "";
    subPageList = [];
    subPageChange() {
        this.pageHandle("subPageList", "subPage");
    }

    voucherPage: string = "";
    pageList: number[] = [];
    pageChange() {
        this.pageHandle("pageList", "voucherPage");
    }

    // 判断凭证是否被打印
    noPrint(index: number, list: string) {
        // @ts-ignore
        if (this[list].length > 0) {
            // @ts-ignore
            for (var i = 0; i < this[list].length; i++) {
                // @ts-ignore
                if (this[list][i] === index) return false;
            }
            return true;
        } else return false;
    }
    // 凭证比例存储缓存
    changePerent(val: number) {
        let percent = val.toString();
        localStorage.setItem("perent", percent);
    }
    // 调整边距
    changReport(margin: number, padding: number) {
        this.reportPadding = padding;
        this.reportMargin = margin;
    }

    // 金账师可填写凭证打印人
    accounter = "";
    casher = "";
    writer = this.$store.state.account.name;

    // 更多设置
    pageOptions = [
        {
            label: "默认凭证纸(21cm * 13cm)",
            value: {
                width: 210000,
                height: 130000,
            },
        },
        {
            label: "A5",
            value: {
                width: 210000,
                height: 148000,
            },
        },
        {
            label: "A3",
            value: {
                width: 297000,
                height: 420000,
            },
        },
        {
            label: "A4",
            value: {
                width: 210000,
                height: 297000,
            },
        },
        {
            label: "发票",
            value: {
                width: 140000,
                height: 240000,
            },
        },
        {
            label: "自定义",
            value: {
                width: 210000,
                height: 130000,
            },
        },
    ];

    voucherPageSize = this.pageOptions[0];
    // 用户选择的凭证尺寸类型
    // voucherPageType: "select" | "input" = "select";

    // 修改选择的纸张自动修改下方输入框的尺寸填写
    voucherPageWidth =
        localStorage.getItem("voucherWidth") === null
            ? this.voucherPageSize.value.width / 10000
            : +(<string>localStorage.getItem("voucherWidth"));
    voucherPageHeight =
        localStorage.getItem("voucherHeight") === null
            ? this.voucherPageSize.value.height / 10000
            : +(<string>localStorage.getItem("voucherHeight"));

    changeVPageSize(option: {
        label: string;
        value: { width: number; height: number };
    }) {
        this.voucherPageWidth = option.value.width / 10000;
        this.voucherPageHeight = option.value.height / 10000;
        this.saveSize();
    }

    saveSize() {
        if (this.isA4Voucher) {
            this.vPrintDir = false;
        } else {
            this.a4Voucher = 0;
        }
        localStorage.setItem("voucherWidth", this.voucherPageWidth.toString());
        localStorage.setItem(
            "voucherHeight",
            this.voucherPageHeight.toString()
        );
        let data = {
            voucherWidth: this.voucherPageWidth.toString(),
            voucherHeight: this.voucherPageHeight.toString(),
            accounterId: this.$store.state.account.id,
        };
        this.changeVDir();
        this.changeA4(true);
        this.saveChange(data);
        for (let i = 0; i < this.pageOptions.length; i++) {
            const v = this.pageOptions[i].value;
            if (
                v.width === +this.voucherPageWidth * 10000 &&
                v.height === +this.voucherPageHeight * 10000
            ) {
                this.voucherPageSize = this.pageOptions[i];
                break;
            }
            this.voucherPageSize =
                this.pageOptions[this.pageOptions.length - 1];
        }
    }

    sheetPageOptions = [
        {
            label: "A4(默认)",
            value: {
                width: 210000,
                height: 297000,
            },
        },
        {
            label: "凭证纸(21cm * 13cm)",
            value: {
                width: 210000,
                height: 130000,
            },
        },
        {
            label: "A5",
            value: {
                width: 210000,
                height: 148000,
            },
        },
        {
            label: "A3",
            value: {
                width: 297000,
                height: 420000,
            },
        },

        {
            label: "自定义",
            value: {
                width: 210000,
                height: 297000,
            },
        },
    ];

    sheetPageSize = this.sheetPageOptions[0];
    // 用户选择的凭证尺寸类型
    // sheetPageType: "select" | "input" = "select";

    // 修改选择的纸张自动修改下方输入框的尺寸填写
    sheetPageWidth =
        localStorage.getItem("sheetWidth") === null
            ? this.sheetPageSize.value.width / 10000
            : +(<string>localStorage.getItem("sheetWidth"));
    sheetPageHeight =
        localStorage.getItem("sheetHeight") === null
            ? this.sheetPageSize.value.height / 10000
            : +(<string>localStorage.getItem("sheetHeight"));

    changeSPageSize(option: {
        label: string;
        value: { width: number; height: number };
    }) {
        this.sheetPageWidth = option.value.width / 10000;
        this.sheetPageHeight = option.value.height / 10000;
        this.saveSheetSize();
    }

    saveSheetSize() {
        localStorage.setItem("sheetWidth", this.sheetPageWidth.toString());
        localStorage.setItem("sheetHeight", this.sheetPageHeight.toString());
        let data = {
            sheetWidth: this.sheetPageWidth.toString(),
            sheetHeight: this.sheetPageHeight.toString(),
            accounterId: this.$store.state.account.id,
        };
        this.saveChange(data);
        for (let i = 0; i < this.sheetPageOptions.length; i++) {
            const v = this.sheetPageOptions[i].value;
            if (
                v.width === +this.sheetPageWidth * 10000 &&
                v.height === +this.sheetPageHeight * 10000
            ) {
                this.sheetPageSize = this.sheetPageOptions[i];
                break;
            }
            this.sheetPageSize =
                this.sheetPageOptions[this.sheetPageOptions.length - 1];
        }
    }

    // 自定义凭证行数
    rowOptions = [3, 4, 5, 6, 7];
    voucherRows = this.$store.state.voucherRows;
    changeRow() {
        this.$store.dispatch("changeVoucherRow", this.voucherRows);
        this.checkVoucher(this.printItems.凭证.show);
        let data = {
            voucherRows: this.voucherRows,
            accounterId: this.$store.state.account.id,
        };
        this.saveChange(data);
    }

    // 选择a4打印凭证，3联凭证行数不能大于5，纸张自动选择a4
    changeA4(noChange?: boolean) {
        if (this.a4Voucher !== 0) {
            this.voucherPageSize = this.pageOptions[3];
            if (!noChange) this.changeVPageSize(this.voucherPageSize);
        }
        if (this.a4Voucher === 3) {
            if (this.voucherRows > 5) this.voucherRows = 5;
            this.changeRow();
        }
        localStorage.setItem("a4Voucher", JSON.stringify(this.a4Voucher));
        let data = {
            aFourVoucher: this.a4Voucher,
            accounterId: this.$store.state.account.id,
        };
        this.saveChange(data);
    }

    // 凭证打印方向控制 true: 横向, false: 纵向（default）
    vPrintDir =
        localStorage.getItem("print-v-dir") === null
            ? false
            : JSON.parse(localStorage["print-v-dir"]);
    sPrintDir =
        localStorage.getItem("print-s-dir") === null
            ? false
            : JSON.parse(localStorage["print-s-dir"]);
    changeVDir() {
        localStorage.setItem("print-v-dir", JSON.stringify(this.vPrintDir));
        let data = {
            printVoucherDir: JSON.stringify(this.vPrintDir),
            accounterId: this.$store.state.account.id,
        };
        this.saveChange(data);
    }
    changeSDir() {
        localStorage.setItem("print-s-dir", JSON.stringify(this.sPrintDir));
        let data = {
            printSheetDir: JSON.stringify(this.sPrintDir),
            accounterId: this.$store.state.account.id,
        };
        this.saveChange(data);
    }

    // 改变行高
    lhOptions = [20, 36, 52, 70];
    lineHeight =
        localStorage.getItem("lh") === null
            ? 1.28
            : +(<string>localStorage.getItem("lh"));
    changeLh() {
        localStorage.setItem("lh", this.lineHeight.toString());
        let data = {
            lh: this.lineHeight.toString(),
            accounterId: this.$store.state.account.id,
        };
        this.saveChange(data);
    }
    voucherFont = localStorage.getItem("voucherFont") === null
        ? 11
        : +(<string>localStorage.getItem("voucherFont"));
    setVoucherFont() {
        localStorage.setItem("voucherFont", this.voucherFont.toString());
        let data = {
            voucherFont: this.voucherFont.toString(),
            accounterId: this.$store.state.account.id,
        };
        this.saveChange(data);
    }

    sheetFont = localStorage.getItem("sheetFont") === null
        ? 11
        : +(<string>localStorage.getItem("sheetFont"));
    setSheetFont() {
        localStorage.setItem("sheetFont", this.sheetFont.toString());
        const data = {
            sheetFont: this.sheetFont.toString(),
            accounterId: this.$store.state.account.id,
        };
        this.saveChange(data);
        this.setSheetFontSize();
    }
    setSheetFontSize() {
        this.$nextTick(() => {
            document.querySelectorAll(".print-table th").forEach((v: any) => {
                // v.setAttribute("style", `font-size: ${this.sheetFont}px`);
                v.style.fontSize = `${this.sheetFont}px`;
            });
            document.querySelectorAll(".print-table td").forEach((v: any) => {
                // v.setAttribute("style", `font-size: ${this.sheetFont}px`);
                v.style.fontSize = `${this.sheetFont}px`;
            });
        });
    }

    async saveChange(data: any) {
        await Vue.axios.post(`accounts/printer/set/save`, data);
    }

    printWay = localStorage.getItem("printWay") === null ? 0 : +<string>localStorage.getItem("printWay");
    changeWay() {
        localStorage.setItem("printWay", this.printWay.toString());
        let data = {
            printWay: this.printWay.toString(),
            accounterId: this.$store.state.account.id,
        };
        this.saveChange(data);
    }

    getA4VoucherPage(index: number) {
        let max = this.vouchers.length;
        if (this.pageList.length > 0) max = Math.max(...this.pageList);
        if (index + 1 === max) return true;
        if (this.a4Voucher !== 0) {        
            if (this.a4Voucher === 2) return (index + 1) % 2 === 0;
            else return (index + 1) % 3 === 0;
        } else return true;
    }
}
